import React from 'react';
import PageBanner from '../../components/PageBanner';
import { productionRouteBanners, productionRouteBannerAlts } from '../../constants/sectionBanners';
import './InvitationCard.css';

const InvitationCard = () => {
  const services = [
    'Digital Invitation Card',
    'Save Date Creative',
    'Social Media Promotion',
    'Printed Invitation Card',
    'Customized Card',
    'Theme based Card',
    'Invitation with Gifts',
  ];

  return (
    <div className="invitation-card-page">
      <PageBanner
        title="Invitation Card"
        image={productionRouteBanners['invitation-card']}
        imageAlt={productionRouteBannerAlts['invitation-card']}
      />
      
      <section className="section">
        <div className="section-container">
          <div className="section-header">
            <h2 className="section-title">Invitation Card Services</h2>
            <div className="title-underline"></div>
            <p className="section-subtitle">
              Beautiful and creative invitation cards for your special events
            </p>
          </div>
          
          <div className="services-grid">
            {services.map((service, index) => (
              <div key={index} className="service-card">
                <h3>{service}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default InvitationCard;
